// Reactインポート
import React, { useState } from "react";
// ゲットナビゲータ
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ScrollToTop from "../ScrollToTop";

// スタイルインポート
import "../pages/css/works.scss";
import "../responsive/WorksResponsive.scss";
import "../common.scss";

// framer motion
import { motion } from "framer-motion";

function Thankyou() {
  return (
    <motion.div
      className="ty"
      initial={{ width: 0 }}
      animate={{ width: "100%" }}
      exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
    >
      <p className="thankyou">
        この度はお問い合わせいただきましてありがとうございます。
      </p>
      <p>内容を確認させていただきまして担当者よりご連絡させていただきます。</p>
      <p>数日経過して折り返しのご連絡がない場合は</p>
      <p>送信エラーの可能性がございますのでお手数ですが</p>
      <p>再度お問い合わせいただけたら幸いです。</p>

      <p className="important">
        ※自動返信メールに関しまして、gmail以外のプラットフォームをご利用中のお客様は
        <br />
        迷惑メールへ届く場合がございますので、あらかじめご確認ください。
      </p>
      <Contact />
      <Footer />
    </motion.div>
  );
}

export default Thankyou;
